import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { useLocation, useNavigate } from "react-router-dom";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { setToastData } from "../../Store/reducers/Toast";
import { ConvertErrorArrayToString } from "../../Services/Common";
import Pagination from "../../Services/Pagination";
import moment from "moment";
const SurveyResponses = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const { accessToken, userData } = useSelector(state => state.user);
    const [surveyData, setSurveyData] = useState({});
    const [filledCount, setFilledCount] = useState([]);
    const [unFilledCount, setUnFilledCount] = useState([]);
    const [totalFilledCount, setTotalFilledCount] = useState(0);
    const [totalUnFilledCount, setTotalUnFilledCount] = useState(0);
    const [responseList, setResponseList] = useState([]);
    const [headers, setHeaders] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [sortField, setSortField] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const perPage = 20;
    useEffect(() => {
        if (!location.state?.survey_id || location.state?.survey_id < 1) {
            navigate('/survey');
        }
        else {
            dispatch(setPageTitle('Survey Responses'));
            getSurveyResponses();
        }
    }, [dispatch]);
    const getSurveyResponses = () => {
        dispatch(setMainLoading(true));
        PostAxios(`survey/responses`, { survey_id: location.state.survey_id, div_id: (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") ? 0 : userData.user_div }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    setSurveyData(data.data);
                    setFilledCount(data.filled_count);
                    setUnFilledCount(data.un_filled_count);
                    setTotalFilledCount(data.total_filled_count);
                    setTotalUnFilledCount(data.total_un_filled_count);
                    setResponseList(data.list);
                    setHeaders(typeof data.list[0] === "object" ? Object.keys(data.list[0]) : []);
                    setCurrentPage(0)
                }
                else {
                    dispatch(setToastData({ message: (Object.values(data.errors).length > 0) ? ConvertErrorArrayToString(data.errors) : data.message, isHtml: true, type: 'error', showCloseBtn: true }))
                }
            })
            .catch(err => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }

    // Sort responses
    const sortedResponses = [...responseList].sort((a, b) => {
        if (!sortField) return 0;
        const valA = a[sortField];
        const valB = b[sortField];
        if (valA < valB) return sortOrder === "asc" ? -1 : 1;
        if (valA > valB) return sortOrder === "asc" ? 1 : -1;
        return 0;
    });

    const handleSort = (field) => {
        setSortOrder(sortField === field && sortOrder === "asc" ? "desc" : "asc");
        setSortField(field);
    };
    const offset = currentPage * perPage;
    const currentResponses = sortedResponses.slice(offset, offset + perPage);
    const exportResponses = () => {
        dispatch(setMainLoading(true));
        let form_data = new FormData();
        form_data.append('survey_id', location.state.survey_id);
        form_data.append('token', accessToken);
        if (userData.role_slug !== "super_admin" && userData.role_slug !== "org_admin") {
            form_data.append('div_id', userData.user_div);
        }
        fetch(`${process.env.REACT_APP_API_URL}survey/export-responses`, {
            method: 'POST',
            body: form_data,
            mode: 'cors',
        })
            .then(response => {
                // Get the blob from the response
                const blob = response.blob();
                // Get the headers from the response
                const headers = response.headers;
                return Promise.all([blob, headers]);
            })
            .then(([blob, headers]) => {
                const contentDisposition = headers.get('Content-Disposition');
                // console.log(headers);
                let fileName = `survey-responses-${moment().format('YYYYMMDDHHmmss')}.xlsx`;
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            })
            .catch(error => responseCatchFunc(dispatch, error))
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const exportUnfilledList = () => {
        dispatch(setMainLoading(true));
        let form_data = new FormData();
        form_data.append('survey_id', location.state.survey_id);
        form_data.append('token', accessToken);
        if (userData.role_slug !== "super_admin" && userData.role_slug !== "org_admin") {
            form_data.append('div_id', userData.user_div);
        }
        fetch(`${process.env.REACT_APP_API_URL}survey/export-unfilled-list`, {
            method: 'POST',
            body: form_data,
            mode: 'cors',
        })
            .then(response => {
                // Get the blob from the response
                const blob = response.blob();
                // Get the headers from the response
                const headers = response.headers;
                return Promise.all([blob, headers]);
            })
            .then(([blob, headers]) => {
                const contentDisposition = headers.get('Content-Disposition');
                // console.log(headers);
                let fileName = `not-filled-survey-responses-${moment().format('YYYYMMDDHHmmss')}.xlsx`;
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        fileName = matches[1].replace(/['"]/g, '');
                    }
                }
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            })
            .catch(error => responseCatchFunc(dispatch, error))
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    return (
        <>
            <div className="card-container">
                <div className="card w-100">
                    <div className="card-content">
                        <h2 className="text-center card-title">{surveyData.title}</h2>
                        <p className="my-3">{surveyData.description}</p>
                    </div>
                </div>
            </div>
            <div className="card-container">
                <div className="card w-50">
                    <div className="card-content">
                        <h3 className="card-title">Responses Filled Count {`( ${totalFilledCount} )`}</h3>
                        <div className="table-wrapper">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th style={{ minWidth: 130 }}>Division</th>
                                        <th>Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filledCount?.map((item, index) => {
                                        return (
                                            <tr key={`filled-count-${index}`}>
                                                <td>{index + 1}</td>
                                                <td>{`${item.division_name} (${item.division_number})`}</td>
                                                <td>{item.response_count}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className="card w-50">
                    <div className="card-content">
                        <h3 className="card-title">Responses Unfilled Count {`( ${totalUnFilledCount} )`}</h3>
                        <div className="table-wrapper">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        <th style={{ minWidth: 130 }}>Division</th>
                                        <th >Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {unFilledCount?.map((item, index) => {
                                        return (
                                            <tr key={`unfilled-count-${index}`}>
                                                <td>{index + 1}</td>
                                                <td>{`${item.division_name} (${item.division_number})`}</td>
                                                <td>{item.unfilled_count}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-container">
                <div className="card w-100">
                    <div className="card-content" style={{ maxHeight: 810 }}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h3 className="card-title">Responses List</h3>
                            <div>
                                <button className="btn btn-blue me-1" onClick={() => getSurveyResponses()}><i className="fas fa-sync"></i> &nbsp;Refresh List</button>
                                <button className="btn btn-blue me-1" onClick={() => exportUnfilledList()}><i className="fas fa-download"></i> &nbsp;Export Unfilled List</button>
                                <button className="btn btn-blue" onClick={() => exportResponses()}><i className="fas fa-download"></i> &nbsp;Export to Excel</button>
                            </div>
                        </div>
                        <div className="table-wrapper">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>S.No.</th>
                                        {headers.map((header) => (
                                            <th key={`sponseList-${header}`} onClick={() => handleSort(header)}>
                                                {header} {sortField === header ? (sortOrder === "asc" ? "↑" : "↓") : ""}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentResponses.map((response, index) => (
                                        <tr key={`responses-${index}`}>
                                            <td>{index + 1}</td>
                                            {headers.map((header) => (
                                                <td key={header}>{response[header]}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <Pagination
                                currentPage={currentPage + 1}
                                totalCount={sortedResponses.length}
                                pageSize={perPage}
                                onPageChange={page => {
                                    setCurrentPage(page - 1);
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SurveyResponses